/**
 * Strict API Payload Models for Status Page
 */

export interface CreateIncidentPayload {
  title: string;
  description: string;
  status: number;
  impact: number;
  affectedServiceIds: number[];
  notifySubscribers: boolean;
  templateId: number | null;
}

export const DEFAULT_CREATE_INCIDENT_PAYLOAD: CreateIncidentPayload = {
  title: "",
  description: "",
  status: 1,
  impact: 2,
  affectedServiceIds: [0],
  notifySubscribers: true,
  templateId: null
};

export interface IncidentUpdatePayload {
  status: number;
  message: string;
  notifySubscribers: boolean;
}

export const DEFAULT_INCIDENT_UPDATE_PAYLOAD: IncidentUpdatePayload = {
  status: 1,
  message: "",
  notifySubscribers: true
};

export type EditIncidentUpdatePayload = Omit<IncidentUpdatePayload, "notifySubscribers">;

export interface CreateMaintenancePayload {
  title: string;
  description: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  notifySubscribers: boolean;
  reminderHoursBeforeStart: number;
  sendReminderAtStart: boolean;
  sendReminderAtEnd: boolean;
  autoStartEnabled: boolean;
  autoCompleteEnabled: boolean;
  affectedServiceIds: number[];
}

export interface UpdateMaintenancePayload {
  title: string;
  description: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  status: number;
  notifySubscribers: boolean;
  reminderHoursBeforeStart: number;
  sendReminderAtStart: boolean;
  sendReminderAtEnd: boolean;
  autoStartEnabled: boolean;
  autoCompleteEnabled: boolean;
}

export const DEFAULT_CREATE_MAINTENANCE_PAYLOAD: CreateMaintenancePayload = {
  title: "",
  description: "",
  scheduledStartDate: "",
  scheduledEndDate: "",
  notifySubscribers: true,
  reminderHoursBeforeStart: 168,
  sendReminderAtStart: true,
  sendReminderAtEnd: true,
  autoStartEnabled: true,
  autoCompleteEnabled: true,
  affectedServiceIds: [0]
};

export interface CompleteMaintenancePayload {
  actualEndDate: string;
}

export interface IncidentTemplateUpdateModel {
  message: string;
  status: number;
  notifySubscribers: boolean;
}

export interface CreateIncidentTemplatePayload {
  name: string;
  titleTemplate: string;
  descriptionTemplate: string;
  defaultStatus: number;
  updateTemplates: IncidentTemplateUpdateModel[];
}

export const DEFAULT_CREATE_INCIDENT_TEMPLATE_PAYLOAD: CreateIncidentTemplatePayload = {
  name: "",
  titleTemplate: "",
  descriptionTemplate: "",
  defaultStatus: 1,
  updateTemplates: [
    {
      message: "",
      status: 1,
      notifySubscribers: true
    }
  ]
};

export interface EditIncidentTemplatePayload {
  name: string;
  titleTemplate: string;
  descriptionTemplate: string;
  defaultStatus: number;
  defaultImpact: number;
  defaultServiceStatus: number;
  updateTemplates: {
    message: string;
    status: number;
    notifySubscribers: boolean;
  }[];
}

export const DEFAULT_EDIT_INCIDENT_TEMPLATE_PAYLOAD: EditIncidentTemplatePayload = {
  name: "",
  titleTemplate: "",
  descriptionTemplate: "",
  defaultStatus: 1,
  defaultImpact: 1,
  defaultServiceStatus: 1,
  updateTemplates: [
    {
      message: "",
      status: 1,
      notifySubscribers: true
    }
  ]
};

export interface MaintenanceTemplatePayload {
  name: string;
  titleTemplate: string;
  descriptionTemplate: string;
  notifySubscribers: boolean;
  reminderHoursBeforeStart: number;
  sendReminderAtStart: boolean;
  sendReminderAtEnd: boolean;
  autoStartEnabled: boolean;
  autoCompleteEnabled: boolean;
}

export const DEFAULT_MAINTENANCE_TEMPLATE_PAYLOAD: MaintenanceTemplatePayload = {
  name: "",
  titleTemplate: "",
  descriptionTemplate: "",
  notifySubscribers: true,
  reminderHoursBeforeStart: 0,
  sendReminderAtStart: true,
  sendReminderAtEnd: true,
  autoStartEnabled: true,
  autoCompleteEnabled: true
};
